

export const FeathersConnectionNames = {
  Main: 'main',
};



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/config/feathers-connection-names.ts